module.exports = __webpack_public_path__ + "static/assets/6dcb8e3a6c09d85576dfefeab8e124e6.svg";